module.exports = __webpack_public_path__ + "media/assets/images/landing/ведомство_10-f509f5137980faadebcfabc7ebb75ed5.png";